// extracted by mini-css-extract-plugin
export default {"p":"c68ff1dbb2 e6c4d977b0 f09f6bdc31","clr":"_9fad8fee32","dls":"_1aca765dd1"};